module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00050.19da155.png";